import { render, staticRenderFns } from "./q6.vue?vue&type=template&id=7bcc17e8&scoped=true&"
import script from "./q6.vue?vue&type=script&lang=js&"
export * from "./q6.vue?vue&type=script&lang=js&"
import style0 from "./q6.vue?vue&type=style&index=0&id=7bcc17e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcc17e8",
  null
  
)

export default component.exports